import _ from 'underscore'
import $ from 'jquery'
import template from 'text-loader!templates/reporting/preview.html'
import Marionette from 'backbone.marionette'
import App from 'app'
import I18n from 'i18n'
import Notificator from 'libraries/notificator'

var ReportPreviewView = Marionette.ItemView.extend({
  template: template,
  serializeData: function () {
    var newsletter = this.model;
    return  {
      title: newsletter.get('title'),
      sender: newsletter.get('sender'),
      recipients: _.map(newsletter.get('recipients'), function (r) { return r.toString(); }).join(', '),
      editable: newsletter.isEditable()
    };
  },
  triggers: {
    'click #deliver': 'clicked:deliver',
    'click #cancel': 'clicked:cancel',
    'click #edit': 'clicked:edit'
  },
  initialize: function () {
    this.on('clicked:deliver', () => {
      this.$('#deliver').attr('disabled', 'disabled');
      this.deliverReport();
    });
    this.on('clicked:edit', () => {
      this.editReport();
    });
    this.on('clicked:cancel', () => {
      var report = this.model;
      report.open();
    });
  },
  onRender: function () {
    this.loadPreview();
  },
  // The preview is shown inside an <iframe>. We can't just point the iframe's
  // `src` at the backend on app.*: an iframe navigation doesn't go through the
  // app's authenticated request layer ($.ajaxPrefilter + withCredentials in
  // app.js), and the session cookie is SameSite=Lax, so the browser wouldn't
  // send it cross-origin and the backend would answer 401 ("refused to
  // connect"). Instead we fetch the preview HTML through that authenticated
  // layer and inject it into the iframe via `srcdoc`.
  loadPreview: function () {
    var view = this;
    $.ajax({
      url: '/api/v3/' + this.model.get('preview_link'),
      dataType: 'html'
    }).done(function (html) {
      var $frame = view.$('.report-preview__frame');
      if ($frame.length) {
        $frame.attr('srcdoc', html);
      }
    }).fail(function () {
      Notificator.showNotification(
        I18n.t('webapp.reporting.notification_messages.report_loading_error')
      );
    });
  },
  editReport: function () {
    var report = this.model;
    report.edit();
  },
  deliverReport: function () {
    var report = this.model;
    var previewView = this;

    report.deliver(function () {
      previewView.$('#deliver').removeAttr('disabled');
      App.Reporting.showReportsList();
    });
  }
});

export default ReportPreviewView;

